import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {MemberModel} from '../../../models/user.model';
import {MemberService} from '../../../services/member.service';
import {HelpersService} from '../../../services/helpers.service';
import {ModalService} from '../../../services/modal/modal.service';

@Component({
    selector: 'app-profile-card-modal',
    templateUrl: './profile-card-modal.component.html',
    styleUrls: ['./profile-card-modal.component.scss']
})
export class ProfileCardModalComponent implements OnInit, AfterViewInit {
    @ViewChild('profileModalView') public profileModalView;
    @Input() public memberGuid: string;
    @Input() public modalView: boolean = true;
    public profile: MemberModel;

    constructor(
        public memberService: MemberService,
        public helper: HelpersService,
        protected modalService: ModalService
    ) {
    }

    ngOnInit(): void {
        this.memberService.getMemberGuid(this.memberGuid).subscribe(res => {
            this.profile = res;
        });
    }

    ngAfterViewInit(): void {
        this.modalView?  this.modalService.openTemplateModal(this.profileModalView) : null
    }
}
